import {
  Colleague,
  DealRoom,
  DealRoomTopNodes,
  LeadStagesCopies,
} from 'models/DealRoom';
import { Dispatch, SetStateAction, createContext } from 'react';
import utils from 'utils';
import { LeadStages } from 'models/Lead';

type DealContextProps = {
  dealRoom: DealRoom;
  isOwner: boolean;
  showGetBuyers: boolean;
  colleagues: Array<Colleague>;
  areColleaguesLoading: boolean;
  dealRoomTopNodes: DealRoomTopNodes[];
  dealRoomStarredNodes: DealRoomTopNodes[];
  leadStagesCopies?: LeadStagesCopies;
  isDataRoomAdmin: boolean;
  setDealRoom: Dispatch<SetStateAction<DealRoom>>;
  setColleagues: Dispatch<SetStateAction<Colleague[]>>;
  onNewOwner: (newOwner: Colleague) => void;
  openDealStatusDrawer: () => void;
  openTransferDrawer: () => void;
  updateLeadStageCopy?: (stage: LeadStages, newValue: string) => void;
};

export default createContext<DealContextProps>({
  dealRoom: null,
  colleagues: [],
  areColleaguesLoading: true,
  isOwner: false,
  showGetBuyers: false,
  dealRoomTopNodes: [],
  dealRoomStarredNodes: [],
  leadStagesCopies: null,
  isDataRoomAdmin: false,
  setDealRoom: utils.noop,
  setColleagues: utils.noop,
  onNewOwner: utils.noop,
  openDealStatusDrawer: utils.noop,
  openTransferDrawer: utils.noop,
  updateLeadStageCopy: utils.noop,
});
